/* Shop-the-look dots.
 *
 * Every product card is rendered by Liquid and sits in the DOM already, so
 * opening one is a class and an attribute — no fetch, no price formatting, and
 * nothing to go wrong on a slow connection. Which way a card opens is decided
 * server-side from the authored position and baked into a class, so this file
 * never measures the viewport.
 */
(function () {
  'use strict';

  /* Both the room tiles and "Shop the look" include this file, and a second
     <script> tag with the same src runs it a second time. Two click handlers
     on one dot toggle the card open and straight back shut. */
  if (window.mineryInspDots) return;
  window.mineryInspDots = true;

  var stages = document.querySelectorAll('[data-m-look]');
  if (!stages.length) return;

  /* With a mouse the dots stay out of the photo until the pointer is over it,
     as on IKEA's own inspiration images; the CSS keys off this class. It is
     set from what the visitor is actually moving, not only from the media
     query, which some touchscreen laptops misreport. Without the class every
     dot is visible — the safe state for a phone, which has no hover to reveal
     them with. */
  var root = document.documentElement;
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    root.classList.add('m-has-mouse');
  }
  document.addEventListener(
    'pointermove',
    function (event) {
      root.classList.toggle('m-has-mouse', event.pointerType !== 'touch');
    },
    { passive: true }
  );

  /* The last kind of pointer that touched a dot: 'mouse', 'pen', 'touch', or
     '' for the keyboard. Decided per event rather than once from a
     (hover: hover) media query, which is false on many touchscreen laptops and
     would switch hover off for a visitor who is plainly using a mouse. */
  var lastPointer = '';

  function cardFor(button) {
    return button.parentNode.querySelector('[data-m-spot-card]');
  }

  function setOpen(button, open) {
    var card = cardFor(button);
    if (!card) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.parentNode.classList.toggle('is-open', open);
    card.hidden = !open;
  }

  function closeAll(stage, except) {
    var buttons = stage.querySelectorAll('[data-m-spot]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i] !== except) setOpen(buttons[i], false);
    }
  }

  for (var s = 0; s < stages.length; s++) {
    (function (stage) {
      var buttons = stage.querySelectorAll('[data-m-spot]');

      for (var i = 0; i < buttons.length; i++) {
        (function (button) {
          button.addEventListener('pointerdown', function (event) {
            lastPointer = event.pointerType;
          });

          /* With a mouse the card has already opened on the way in, so a click
             means "take me there" — the product page, as on IKEA. A touch has
             no hover to preview with, so the first tap opens the card and the
             card's own link goes on from there. Enter from the keyboard also
             follows the link: focus has already shown the card. */
          button.addEventListener('click', function (event) {
            event.preventDefault();
            var viaTouch = lastPointer === 'touch' && event.detail > 0;
            lastPointer = '';
            var url = button.getAttribute('data-m-spot-url');

            if (!viaTouch && url) {
              window.location.href = url;
              return;
            }

            var isOpen = button.getAttribute('aria-expanded') === 'true';
            closeAll(stage, button);
            setOpen(button, !isOpen);
          });

          /* pointerenter carries the pointer type, so a touch — which fires
             it too, just before the tap — cannot open the card here and then
             have the tap close it again. */
          button.addEventListener('pointerenter', function (event) {
            if (event.pointerType === 'touch') return;
            closeAll(stage, button);
            setOpen(button, true);
          });
          button.parentNode.addEventListener('pointerleave', function (event) {
            if (event.pointerType === 'touch') return;
            setOpen(button, false);
          });

          /* Keyboard users land on the dot with Tab; the card has to come with
             it or the product is unreachable without a mouse. */
          button.addEventListener('focus', function () {
            /* A press focuses the button too. Leave that to pointerenter and
               click, or a tap would open the card here and toggle it shut. */
            if (lastPointer) return;
            closeAll(stage, button);
            setOpen(button, true);
          });
        })(buttons[i]);
      }

      stage.addEventListener('focusout', function (event) {
        if (!stage.contains(event.relatedTarget)) closeAll(stage);
      });

      /* A card left open on a photo that has scrolled away would still be
         open, unseen, when the visitor scrolls back; close it on the way out. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) closeAll(stage);
          },
          { threshold: 0 }
        ).observe(stage);
      }
    })(stages[s]);
  }

  document.addEventListener('click', function (event) {
    for (var i = 0; i < stages.length; i++) {
      if (!stages[i].contains(event.target)) closeAll(stages[i]);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    for (var i = 0; i < stages.length; i++) closeAll(stages[i]);
  });
})();
